import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import { DuLieuHeThong } from 'api';

class DropDownChonHinhThucDaGiaiQuyet extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      data: this.props.data
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      DuLieuHeThong.actions.getHinhThucDaGiaiQuyet.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'hinhThucDaGiaiQuyet',
            data: res.data || []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown label="Hình thức đã giải quyết" require={this.props.require} options={this.state.data} keyName='giaTri' valueName='ten' onChange={this.onChange.bind(this)} placeholder={this.props.placeholder} className={'col-input '+this.props.className} selectedValue={this.props.selectedValue}/>
    )
  }
}

DropDownChonHinhThucDaGiaiQuyet.defaultProps = {
  className: 'input-group',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  data: []
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.hinhThucDaGiaiQuyet
  }
}

export default connect(bindStateToProps)(DropDownChonHinhThucDaGiaiQuyet);


// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonhinhthucdagiaiquyet.jsx